// import { lazy } from 'react'

import { useLocation, useNavigate, useRoutes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { type IUserProfile } from '../../src/redux/api/types'

import LoginRoutes from './LoginRoutes'
import MainRoutes from './MainRoutes'
import { useEffect } from 'react'
import { isPathLogged } from '../utils/isPathLogged'
import { PATH, PATH_LOGIN } from './constant'
import { LINKS } from '../utils/constants/links'

export default function ThemeRoutes () {
  const navigate = useNavigate()
  const logged = useSelector((state: { userState: { user: IUserProfile } }) => state.userState.user)
  const { pathname } = useLocation()

  useEffect(() => {
    if (!logged && isPathLogged(pathname) && pathname !== PATH.HOME) {
      navigate(PATH_LOGIN.LOGIN, {
        state: {
          isSessionOver: true,
          prev: pathname
        }
      })
    }

    if (logged?.isOmniCustomer && pathname === PATH.ACCOUNT) {
      navigate(PATH.HOME, {
        state: {
          isSessionOver: false,
          prev: pathname
        }
      })
    }

    if (!logged?.account.websiteUrl && pathname === LINKS.MANAGE_WEBSITE) {
      navigate(PATH.HOME, {
        state: {
          isSessionOver: false,
          prev: pathname
        }
      })
    }
  }, [logged, pathname])
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  return useRoutes([logged ? MainRoutes : LoginRoutes])
}
